const CustomAutoCompleteStyles = {
  autoComplete: {
    "& .MuiInputBase-input": { padding: "13px 13px", height: "13px" },
  },
} as const;

export default CustomAutoCompleteStyles;
